query lpLevels($seasonId: Int, $withUserData: Boolean!) {
  lpLevels(seasonId: $seasonId) {
    id
    availableForUser
    availableByDep
    propsContent {
      id
      title
      type
      props
      images {
        id
        compressedImage {
          webp {
            lg
            md
            sm
            xl
            xs
          }
        }
      }
    }
    numLevel
    name
    requiredXp
    categories {
      isCompleted
      rewardClaimed
      activeSettings {
        activeStart
        activeEnd
      }
      actions {
        id
      }
      tasks {
        userTask @include(if: $withUserData) {
          id
          isCompleted
          rewardClaimed
          amount
        }
        actions {
          id
        }
      }
    }
  }
}
